/* Shopify owns the secure sign-in sheet, authentication and its focus trap.
   Keep a working native link if their component is delayed or unavailable. */
(() => {
  if (!window.customElements || customElements.get('bd-account-entry')) return;
  class BDAccountEntry extends HTMLElement {
    connectedCallback() {
      this.fallback = this.querySelector('[data-account-fallback]');
      this.account = this.querySelector('shopify-account');
      if (!this.fallback || !this.account || this.dataset.accountReady) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.fallback.addEventListener('blur', () => this.activate(), {signal});
      this.fallback.addEventListener('pointerleave', () => this.activate(), {signal});
      customElements.whenDefined('shopify-account').then(() => {
        if (!this.isConnected || signal.aborted) return;
        requestAnimationFrame(() => {
          if (signal.aborted) return;
          // Read only the rendered DOM, never private component state/methods.
          // If Shopify changes to a closed shadow root, the native link remains.
          const root = this.account.shadowRoot;
          if (!root) return;
          this.observer = new MutationObserver(() => this.activate());
          this.observer.observe(root, {childList: true, subtree: true, attributes: true});
          this.activate();
          if (!this.dataset.accountReady) this.timeout = setTimeout(() => this.observer.disconnect(), 15000);
        });
      });
    }
    activate() {
      if (!this.isConnected || this.dataset.accountReady) return;
      const trigger = this.account.shadowRoot?.querySelector('[part~="signed-out-avatar"], button[aria-haspopup], button');
      if (!trigger || trigger.disabled || trigger.hidden) return;
      // Never replace a link while someone is focusing or pressing it.
      if (document.activeElement === this.fallback || this.fallback.matches(':hover, :active')) return;
      this.observer?.disconnect();
      clearTimeout(this.timeout);
      this.account.hidden = false;
      this.account.inert = false;
      this.account.removeAttribute('aria-hidden');
      this.fallback.hidden = true;
      this.dataset.accountReady = 'true';
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timeout);
    }
  }
  customElements.define('bd-account-entry', BDAccountEntry);
})();
